import PropTypes from 'prop-types';
import MeetingOptions from './MeetingOptions';
import './Calendar.css';

function Meeting({ meeting }) {
  return (
    <li className="meeting-item-wrapper">
      <div
        className="meeting-flag"
        style={{
          background: meeting.color,
        }}
      />
      <div className="meeting-item">
        <p className="meeting-title">{meeting.title}</p>
        <p className="meeting-description">Opis zadatka ili aktivnosti</p>
      </div>
      <div className="meeting-menu">
        <MeetingOptions>
          <i className="fas fa-ellipsis-v" style={{ fontSize: '16px' }} />
        </MeetingOptions>
      </div>
    </li>
  );
}

export default Meeting;

Meeting.propTypes = {
  meeting: PropTypes.object.isRequired,
};
